
import {tap} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AfterViewChecked, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { QualityType, RequeteCategory, RequeteService } from '../../../entities/requete';
import { AccountService, ScrollToService, UserService } from '../../../shared';
import { SectionState } from '../../../shared/components/section/section.model';
import { ErrorService } from '../../../shared/services/error.service';
import { DepotRequeteState } from '../../depot-requete-state.model';
import { DraftDepotRequeteService } from '../../draft-depot-requete.service';

@Component({
    templateUrl: './requerants.component.html',
    styleUrls: ['requerants.component.scss']
})
export class RequerantsComponent implements AfterViewChecked, OnInit {
    depotRequeteState: DepotRequeteState;
    RequeteCategoryEnum = RequeteCategory;
    nombreRequetes = 0;
    sections: { [key: string]: SectionState } = {
        selectTypeRequete: { index: 1, isToggleable: false, isHelpOpen: false },
        displayActeur: { index: 2, isToggleable: false },
        addRequerant: { index: 3, isToggleable: false, isHelpOpen: true }
    };

    private scrollTarget: string;
    private scrollToError = false;
    public autoSaveError = false;

    @Output() previousStep: EventEmitter<any> = new EventEmitter();
    @Output() nextStep: EventEmitter<any> = new EventEmitter();
    @Output() hideAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showErrorAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showSuccessAlertDraft: EventEmitter<any> = new EventEmitter();

    @ViewChild(NgForm) form: NgForm;

    constructor(
        private requeteService: RequeteService,
        private userService: UserService,
        private accountService: AccountService,
        private errorService: ErrorService,
        private scrollToService: ScrollToService,
        private router: Router,
        private draftDepotRequeteService: DraftDepotRequeteService,
    ) {
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        this.userService
            .getAccount()
            .then(
                account => (this.depotRequeteState.currentActeur = this.accountService.mapAccountToPartieDepot(account))
            );
        this.getNombreRequetesAujourdhui();
    }

    ngOnInit(): void {
        this.hideAlertDraft.emit();
    }

    ngAfterViewChecked(): void {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    }

    next(): Observable<void> {
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            if (this.depotRequeteState.requeteCategory === RequeteCategory.REQUERANT_SEUL) {
                this.depotRequeteState.currentActeur.qualite = QualityType.Requerant;
                this.depotRequeteState.requerants.push(this.depotRequeteState.currentActeur);
            }
            return this.saveRequerants().pipe(tap(
                () => {
                    this.depotRequeteState.isStepRequerantAutoSaveSucceed = true;
                    this.nextStep.emit();
                },
                (error) => {
                    this.autoSaveError = true;
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                }
            ));
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    }

    previous(): void {
        this.previousStep.emit();
    }

    saveDraft(): Observable<any> {
        this.hideAlertDraft.emit();

        return this.saveRequerants().pipe(tap(
            () => {
                this.showSuccessAlertDraft.emit();
            },
            (error) => {
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        ));
    }

    saveDraftAgain(): any {
         this.saveRequerants().subscribe(
            () => {
                this.showSuccessAlertDraft.emit();
            },
            (error) => {
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        );
    }

    close() {
        this.autoSaveError = false;
    }

    onRequerantTypeChange(requeteCategory: RequeteCategory): void {
        this.depotRequeteState.requeteCategory = requeteCategory;
        this.resetRequerants();
        this.scrollTarget = 'jhi-requerant-type-section';
    }

    resetRequerants(): void {
        this.depotRequeteState.requerants = [];
        let addRequerantControl = this.form.controls['add-requerant'];
        if (addRequerantControl) {
            addRequerantControl.markAsUntouched();
            addRequerantControl.markAsPristine();
        }
    }

    hasCaptcha(): boolean {
        return this.nombreRequetes >= 1;
    }

    goToProfile() {
        this.router.navigate(['/mon-profil']);
    }

    public saveRequerants(): Observable<any> {
        if (this.depotRequeteState.requeteCategory !== undefined) {
            return this.draftDepotRequeteService.saveParties(
                this.depotRequeteState.requeteCategory,
                this.depotRequeteState.requerants
            );
        }
    }

    private getNombreRequetesAujourdhui() {
        this.requeteService.readRequeteNumberToday().subscribe(res => {
            this.nombreRequetes = res;
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requerants/requerants.component.ts